import { useState, useEffect } from 'react';
import './appointments.css';
import UpcomingAppointments from './UpcomingAppointments';
import BreadCrum from '../features/breadcrum/BreadCrum';
import AppointmentDetails from './Appointment-details';
import PreviousAppointments from './PreviousAppointments';
import { useSelector, useDispatch } from 'react-redux';
import { Spin } from 'antd';
import { getCustomerAppointments, getPreviousAppointments } from '../redux/appointments/appointmentAction';

const Appointments = () => {
    const dispatch = useDispatch();
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [upcomingActiveIndex, setUpcomingActiveIndex] = useState(undefined);
    const [previousActiveIndex, setPreviousActiveIndex] = useState(undefined);
    const [prevAppointmentsLength, setPrevAppointmentsLength] = useState(0);

    const { cutomerAppointments, previousAppointments, isLoading } = useSelector(
        (state) => state.appointments
    );

    const hasAppointments = (cutomerAppointments && cutomerAppointments.length > 0) || (previousAppointments && previousAppointments.length > 0);

    useEffect(() => {
        dispatch(getCustomerAppointments());
        dispatch(getPreviousAppointments());
    }, [dispatch]);

    useEffect(() => {
        if (!isLoading && cutomerAppointments) {
            if (cutomerAppointments.length > 0) {
                if (selectedAppointment === null || cutomerAppointments.length !== prevAppointmentsLength) {
                    setSelectedAppointment(cutomerAppointments[0]);
                    setUpcomingActiveIndex(0);
                    setPreviousActiveIndex(undefined);
                    setPrevAppointmentsLength(cutomerAppointments.length);
                }
            } else if (cutomerAppointments.length === 0 && prevAppointmentsLength !== 0) {
                setSelectedAppointment(null);
                setUpcomingActiveIndex(undefined);
                setPreviousActiveIndex(undefined);
                setPrevAppointmentsLength(0);
            }
        }
    }, [cutomerAppointments, isLoading, selectedAppointment, prevAppointmentsLength]);

    return (
        <div className="mb-5 container p-4 position-relative" style={{ minHeight: '500px' }}>
            <BreadCrum
                items={[
                    { title: 'Home', path: '/home' },
                    {
                        title: 'Appointments',
                        path: '/customer/upcoming-appointments',
                    },
                ]}
            />
            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <Spin size="large" />
                </div>
            ) : (
                <div className="row d-flex justify-space-between">
                    <div className="col-lg-4 col-sm-12 mb-3">
                        <UpcomingAppointments
                            activeIndex={upcomingActiveIndex}
                            returnSelectedAppointment={(index, obj) => {
                                setSelectedAppointment(obj);
                                setPreviousActiveIndex(undefined);
                                setUpcomingActiveIndex(index);
                            }}
                        />
                        <PreviousAppointments
                            activeIndex={previousActiveIndex}
                            returnSelectedAppointment={(index, obj) => {
                                setSelectedAppointment(obj);
                                setUpcomingActiveIndex(undefined);
                                setPreviousActiveIndex(index);
                            }}
                        />
                    </div>
                    <div className="col-lg-8 col-sm-12">
                        {selectedAppointment !== null ? (
                            <AppointmentDetails
                                selectedAppointment={selectedAppointment}
                                setSelectedAppointment={setSelectedAppointment}
                            />
                        ) : (
                            <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center px-4" style={{ minHeight: '450px' }}>
                                <div className="mb-4">
                                    <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z" stroke="#2b5c35" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="12" cy="15" r="2" fill="#2b5c35" />
                                    </svg>
                                </div>
                                {(!cutomerAppointments || cutomerAppointments.length === 0) && (previousAppointments && previousAppointments.length > 0) ? (
                                    <>
                                        <h4 className="fw-bold poly mb-2" style={{ color: '#2b5c35', fontSize: '22px' }}>No Upcoming Bookings</h4>
                                        <p className="poppins text-muted mb-4" style={{ maxWidth: '380px', fontSize: '15px', lineHeight: '1.6' }}>
                                            You don't have any upcoming appointments scheduled. Search for salons near you and book a new service with your favorite salons now!
                                        </p>
                                    </>
                                ) : (!cutomerAppointments || cutomerAppointments.length === 0) && (!previousAppointments || previousAppointments.length === 0) ? (
                                    <>
                                        <h4 className="fw-bold poly mb-2" style={{ color: '#2b5c35', fontSize: '22px' }}>Search Salon & Book</h4>
                                        <p className="poppins text-muted mb-4" style={{ maxWidth: '380px', fontSize: '15px', lineHeight: '1.6' }}>
                                            You don't have any upcoming or past appointments. Search for salons near you and book your first service!
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <h4 className="fw-bold poly mb-2" style={{ color: '#0f151d', fontSize: '22px' }}>Select an Appointment</h4>
                                        <p className="poppins text-muted mb-0" style={{ maxWidth: '340px', fontSize: '15px', lineHeight: '1.6' }}>
                                            Click on any upcoming or previous appointment from the list to view its details, service details, and maps.
                                        </p>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Appointments;
